import { openDB, type DBSchema, type IDBPDatabase } from 'idb'

const LEGAL_DOCS_VERSION = '2026-06-16'

interface LegalDb extends DBSchema {
  meta: {
    key: string
    value: string | boolean
  }
}

let dbPromise: Promise<IDBPDatabase<LegalDb>> | null = null

function getDb(): Promise<IDBPDatabase<LegalDb>> {
  if (!dbPromise) {
    dbPromise = openDB<LegalDb>('zion-legal', 1, {
      upgrade(db) {
        if (!db.objectStoreNames.contains('meta')) db.createObjectStore('meta')
      },
    })
  }
  return dbPromise
}

export const LEGAL_URLS = {
  terms: 'https://www.zionyx.ch/legal/termini',
  privacy: 'https://www.zionyx.ch/legal/privacy',
  docsVersion: LEGAL_DOCS_VERSION,
} as const

export async function hasAcceptedLegal(): Promise<boolean> {
  const db = await getDb()
  const privacy = (await db.get('meta', 'legal_privacy')) === true
  const terms = (await db.get('meta', 'legal_terms')) === true
  const version = (await db.get('meta', 'legal_version')) === LEGAL_DOCS_VERSION
  return privacy && terms && version
}

export async function setLegalAccepted(privacyAccepted: boolean, termsAccepted: boolean): Promise<void> {
  const db = await getDb()
  await db.put('meta', privacyAccepted, 'legal_privacy')
  await db.put('meta', termsAccepted, 'legal_terms')
  await db.put('meta', LEGAL_DOCS_VERSION, 'legal_version')
}

export async function clearLegalAcceptance(): Promise<void> {
  const db = await getDb()
  await db.clear('meta')
}
